module.exports = __webpack_public_path__ + "img/choose-up-11_1 virtual_text.fdd86d11.png";